import React from 'react';
import IconPhone from 'yoda-core-components/lib/assets/svg/IconPhone.svg';
import CustomerService from 'yoda-core-components/lib/assets/svg/CustomerService.svg';
import IconTwitter from 'yoda-core-components/lib/assets/svg/IconTwitter.svg';
import MailFill from 'yoda-core-components/lib/assets/svg/MailFill.svg';
import SocialmediaFacebook from 'yoda-core-components/lib/assets/svg/SocialmediaFacebook.svg';
import SocialmediaTwitter from 'yoda-core-components/lib/assets/svg/SocialmediaTwitter.svg';
import SocialmediaPinterest from 'yoda-core-components/lib/assets/svg/SocialmediaPinterest.svg';
import InstagramLine from 'yoda-core-components/lib/assets/svg/InstagramLine.svg';
import SocialmediaYoutube from 'yoda-core-components/lib/assets/svg/SocialmediaYoutube.svg';
import SocialmediaBlog from 'yoda-core-components/lib/assets/svg/SocialmediaBlog.svg';

export const helpSectionIconMapping = {
    'icon-phone': <IconPhone />,
    'mail-fill': <MailFill />,
    'customer-service': <CustomerService />,
    'icon-twitter': <IconTwitter />,
};

export const footerLinksIconMapping = {
    'socialmedia-facebook': <SocialmediaFacebook />,
    'socialmedia-twitter': <SocialmediaTwitter />,
    'socialmedia-pinterest': <SocialmediaPinterest />,
    'instagram-line': <InstagramLine />,
    'socialmedia-youtube': <SocialmediaYoutube />,
    'socialmedia-blog': <SocialmediaBlog />,
};
